import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3 0H18C19.6406 0 21 1.35938 21 3V18C21 19.6875 19.6406 21 18 21H3C1.3125 21 0 19.6875 0 18V3C0 1.35938 1.3125 0 3 0ZM6.70312 6.70312C6.23438 7.17188 6.23438 7.875 6.70312 8.29688L8.90625 10.5L6.70312 12.7031C6.23438 13.1719 6.23438 13.875 6.70312 14.2969C7.125 14.7656 7.82812 14.7656 8.25 14.2969L10.4531 12.0938L12.6562 14.2969C13.125 14.7656 13.8281 14.7656 14.25 14.2969C14.7188 13.875 14.7188 13.1719 14.25 12.7031L12.0469 10.5L14.25 8.29688C14.7188 7.875 14.7188 7.17188 14.25 6.70312C13.8281 6.28125 13.125 6.28125 12.6562 6.70312L10.4531 8.90625L8.25 6.70312C7.82812 6.28125 7.125 6.28125 6.70312 6.70312Z",
		fill: "#D91734"
	})]
});
const ForwardRef = forwardRef(SvgIconError);
export { ForwardRef as ReactComponent };
